import { useState } from 'react';

import PropTypes from 'prop-types';

import CollectionCreatePlaceholder from './CollectionCreatePlaceholder';
import { collectionItemShape } from './collectionItemShape';
import CollectionRow from './CollectionRow';
import CollectionTile from './CollectionTile';

const LAYOUTS = {
	grid: { container: 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4', Item: CollectionTile },
	list: { container: 'flex flex-col gap-3', Item: CollectionRow },
};

const CollectionView = ({ items, viewMode, isLoading = false, emptyLabel, createLabel, onCreate }) => {
	const [renamingId, setRenamingId] = useState(null);

	if (isLoading) {
		return (
			<div className="flex justify-center py-12">
				<div className="h-7 w-7 animate-spin rounded-full border-b-2 border-primary-500" />
			</div>
		);
	}

	const { container, Item } = LAYOUTS[viewMode];

	return (
		<>
			{items.length === 0 && emptyLabel && (
				<p className="pb-5 pt-2 text-center text-sm text-bgBase-800">{emptyLabel}</p>
			)}
			<div className={container}>
				{items.map((item) => (
					<Item
						key={item.id}
						item={item}
						isRenaming={renamingId === item.id}
						onRenameStart={() => setRenamingId(item.id)}
						onRenameEnd={() => setRenamingId(null)}
					/>
				))}
				{onCreate && <CollectionCreatePlaceholder label={createLabel} onClick={onCreate} layout={viewMode} />}
			</div>
		</>
	);
};

CollectionView.propTypes = {
	items: PropTypes.arrayOf(collectionItemShape).isRequired,
	viewMode: PropTypes.oneOf(['grid', 'list']).isRequired,
	isLoading: PropTypes.bool,
	emptyLabel: PropTypes.string,
	createLabel: PropTypes.string,
	onCreate: PropTypes.func,
};

export default CollectionView;
